<template>
  <v-container fluid class="px-0">
    <v-row  dense>
      <v-col
        v-for="item in modelList"
        :key="item.key"
        :cols="parseInt(12 / nCol)"
        class="d-flex child-flex"
      >
        <v-hover v-if="item.uuid != null" v-slot="{ hover }" open-delay="50">
          <v-card v-if="hover" elevation="10" tile>
            <v-img
              :src="addrPrefix + '/' + item.h15_img"
              :lazy-src="addrPrefix + '/' + item.img"
              :alt="item.uuid"
              class="grey lighten-2"
              :aspect-ratio="4/3"
              :position="h15_center"
              @click="$emit('select-it', item.uuid, item.modality)"
              @mousemove="showFakeModel"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0 align-center justify-center">
                  <v-col class="text-center" cols="12">
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-col>
                </v-row>
              </template>
            </v-img>
          </v-card>
          <v-card v-else outlined >
            <v-img
              :src="addrPrefix + '/' + item.img"
              :alt="item.uuid"
              :aspect-ratio="4/3"
              class="grey lighten-2"
              contain
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0 align-center justify-center">
                  <v-col class="text-center" cols="12">
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-col>
                </v-row>
              </template>
            </v-img>
          </v-card>
        </v-hover>
        <template v-else>
          <v-responsive :aspect-ratio="4/3"> </v-responsive>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ModelGallery",

  props: {
    modelList: {
      type: Array,
      required: true,
    },
    addrPrefix: {
      type: String,
      requird: true,
    },
    nRow: {
      type: Number,
      required: true,
    },
    nCol: {
      type: Number,
      required: true,
    },
  },

  data: () => ({
    h15_center: "0% center",
  }),

  created() {
    // console.log(this.modelList === undefined)
    // console.log(this.modelList);
    // console.log(this.nCol);
  },

  methods: {
    showFakeModel(e) {
      let n_frame = 15;
      let frame_idx = Math.floor(
        (e.layerX / (e.target.clientWidth + 1)) * n_frame
      );
      let center_pos = 100 - 100 * (frame_idx / (n_frame - 1));
      this.h15_center = center_pos + "%";
    },
  },
};
</script>
